import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import classNames from 'classnames';
import compose from '../../hoc/compose';
import DockingPlane from './dockingPlaneButton';
import Tooltip from '../tooltip/tooltip';
var DockingPanel = /*#__PURE__*/function (_React$Component) {
  function DockingPanel() {
    _classCallCheck(this, DockingPanel);
    return _callSuper(this, DockingPanel, arguments);
  }
  _inherits(DockingPanel, _React$Component);
  return _createClass(DockingPanel, [{
    key: "_getDockingState",
    value: function _getDockingState(direction) {
      var docked = _.includes(this.props.value, direction) ? 'direction-docked' : '';
      var disabled = _.includes(this.props.disabledDirections, direction) ? 'direction-disabled' : '';
      return disabled || docked;
    }
  }, {
    key: "_generateCenterPlane",
    value: function _generateCenterPlane() {
      var _this = this;
      var vertical = _.includes(this.props.value, 'VERTICAL');
      var horizontal = _.includes(this.props.value, 'HORIZONTAL');
      var onChange = function onChange(direction) {
        return _this._updateDockingState(direction);
      };
      var _this$props = this.props,
        shouldTranslate = _this$props.shouldTranslate,
        hintVertical = _this$props.hintVertical,
        hintHorizontal = _this$props.hintHorizontal,
        centerHint = _this$props.centerHint,
        disabled = _this$props.disabled,
        disabledDirections = _this$props.disabledDirections;
      return /*#__PURE__*/React.createElement(DockingPlane, {
        disabled: disabled,
        vertical: vertical,
        horizontal: horizontal,
        onChange: onChange,
        shouldTranslate: shouldTranslate,
        hintVertical: hintVertical,
        hintHorizontal: hintHorizontal,
        centerHint: centerHint,
        disabledDirections: disabledDirections
      });
    }
  }, {
    key: "_toggleSelectionStateFor",
    value: function _toggleSelectionStateFor(direction) {
      return _.includes(this.props.value, direction) ? _.without(this.props.value, direction) : _.concat(this.props.value, direction);
    }
  }, {
    key: "_updateDockingState",
    value: function _updateDockingState(direction) {
      if (!this.props.disabled && !this.props.disabledDirections.includes(direction)) {
        this.props.onChange(this._toggleSelectionStateFor(direction));
      }
    }
  }, {
    key: "_generateTooltip",
    value: function _generateTooltip(direction, hint) {
      var _this2 = this;
      return /*#__PURE__*/React.createElement("div", {
        "data-direction": direction,
        className: 'docking-direction ' + direction + ' ' + this._getDockingState(direction.toUpperCase())
      }, /*#__PURE__*/React.createElement(Tooltip, {
        dataHook: direction + '-tooltip',
        content: hint,
        disabled: !hint,
        isHint: true,
        alignment: "TOP"
      }, /*#__PURE__*/React.createElement("div", {
        className: "docking-point",
        "data-hook": direction + '-direction',
        onClick: function onClick() {
          return _this2._updateDockingState(direction.toUpperCase());
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "docking-line"
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        topHint = _this$props2.topHint,
        leftHint = _this$props2.leftHint,
        rightHint = _this$props2.rightHint,
        bottomHint = _this$props2.bottomHint;
      return /*#__PURE__*/React.createElement("div", {
        "data-aid": this.props.automationId,
        "data-hook": this.props.dataHook,
        className: classNames(this.props.getClassName('control-docking-panel-outer'), {
          'is-disabled': this.props.disabled
        })
      }, /*#__PURE__*/React.createElement("div", {
        className: "docking-panel-inner"
      }, this._generateTooltip('top', topHint), /*#__PURE__*/React.createElement("div", {
        className: "docking-rail left"
      }, this._generateTooltip('left', leftHint)), /*#__PURE__*/React.createElement("div", {
        className: "docking-element center"
      }, this._generateCenterPlane()), /*#__PURE__*/React.createElement("div", {
        className: "docking-rail right"
      }, this._generateTooltip('right', rightHint)), this._generateTooltip('bottom', bottomHint)));
    }
  }]);
}(React.Component);
DockingPanel.displayName = 'DockingPanel';
DockingPanel.propTypes = {
  /** Callback to be called on direction change */
  onChange: PropTypes.func.isRequired,
  /** Selected directions */
  value: PropTypes.arrayOf(PropTypes.string),
  /** Directions than can not be selected */
  disabledDirections: PropTypes.arrayOf(PropTypes.string),
  disabled: PropTypes.bool,
  // todo: does this prop do anything?
  /** Content to be displayed on tooltip while hovering over vertical direction in plane */
  hintVertical: PropTypes.string,
  /** Content to be displayed on tooltip while hovering over horizontal direction in plane */
  hintHorizontal: PropTypes.string,
  /** Hint to be displayed while hovering over top docking point */
  topHint: PropTypes.string,
  /** Hint to be displayed while hovering over left docking point */
  leftHint: PropTypes.string,
  /** Hint to be displayed while hovering over right docking point */
  rightHint: PropTypes.string,
  /** Hint to be displayed while hovering over right docking point */
  bottomHint: PropTypes.string,
  /** Hint to be displayed while hovering over center docking button */
  centerHint: PropTypes.string
};
DockingPanel.defaultProps = {
  disabled: false,
  value: [],
  disabledDirections: [],
  hintVertical: null,
  hintHorizontal: null,
  topHint: null,
  leftHint: null,
  rightHint: null,
  bottomHint: null,
  centerHint: null
};
export default compose(DockingPanel);